module.exports = __webpack_public_path__ + "img/profile_icon.3cf22823.svg";